import React from 'react';
import cn from 'classnames';
import st from './percentCircle.module.scss'


interface PercentCircleProps {
    
    percent: number
    size: string
    color: string
    bgColor: string
}

const PercentCircle = (props: PercentCircleProps) => {
    const { percent, size, color, bgColor} = props;

    return (
        <svg viewBox="0 0 36 36"
            className={cn({
                [st.circularChart]: true,
                [st.large]: size && size === 'large',
                [st.huge]: size && size === 'huge',
            })
            }
        >
            <path className={st.circleBg} stroke={'#EBECF0'}
                d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path className={st.circle} stroke={color}
                strokeDasharray={`${percent}, 100`}
                d="M18 2.0845
        a 15.9155 15.9155 0 0 1 0 31.831
        a 15.9155 15.9155 0 0 1 0 -31.831"
            />
        </svg>)
}




export default PercentCircle;